import React from "react";

//Iconos
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCartShopping,
  faPencil
} from "@fortawesome/free-solid-svg-icons";

const RRProveedor = ({p,index,handleEditProveedor}) =>{

    return <div className="rrLegajoDiv">
            <FontAwesomeIcon icon={faCartShopping} className="rrIcon"/>
            <div className="infoDiv">
                <h6>Núm. Cuenta:</h6>
                <label>{p.nroCta}</label>
            </div>
            <div className="infoDiv">
                <h6>Nombre:</h6>
                <label>{p.nombre}</label>
            </div>
            <div className="utilitesDiv" onClick={()=>handleEditProveedor(p)}>
                <FontAwesomeIcon className="utilityIcon" icon={faPencil}/>
            </div>
    </div>

}

export default RRProveedor;